import React, { useEffect } from 'react';
import { Paper, Typography, Button, Stack, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SnoozeIcon from '@mui/icons-material/Snooze';
import { trackEvent } from '../services/analytics';

export default function SilentMentorNudge({ nudgeId = 'silent_mentor_1', title, message, actionLabel, onAction, onDismiss, onSnooze, meta = {} }) {
  useEffect(() => {
    trackEvent('silent_mentor_nudge_shown', { nudgeId, meta });
  }, [nudgeId, meta]);

  const handleAction = () => {
    trackEvent('silent_mentor_nudge_clicked', { nudgeId, meta, action: actionLabel });
    if (onAction) onAction();
  };

  const handleDismiss = () => {
    trackEvent('silent_mentor_nudge_dismissed', { nudgeId, meta });
    if (onDismiss) onDismiss();
  };

  const handleSnooze = () => {
    trackEvent('silent_mentor_nudge_snoozed', { nudgeId, meta });
    if (onSnooze) onSnooze(24); // default 24 hours
  };

  return (
    <Paper sx={{ p: 2, mb: 2, backgroundColor: 'rgba(25,118,210,0.04)' }} elevation={0}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
        <div>
          {title && (
            <Typography variant="subtitle2" color="text.secondary">
              {title}
            </Typography>
          )}
          <Typography variant="body2">{message}</Typography>
        </div>
        <Stack direction="row" spacing={1} alignItems="center">
          {actionLabel && (
            <Button size="small" variant="contained" onClick={handleAction}>
              {actionLabel}
            </Button>
          )}
          <IconButton size="small" aria-label="snooze" onClick={handleSnooze} title="Snooze for 24h">
            <SnoozeIcon fontSize="small" />
          </IconButton>
          <IconButton size="small" aria-label="dismiss" onClick={handleDismiss} title="Dismiss">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Stack>
      </Stack>
    </Paper>
  );
}
